import React from 'react'
import createReactClass from 'create-react-class'
import './login-form.scss'

export default createReactClass({
  getInitialState () {
    return {
      username: '',
      password: '',
      env: 'live',
      validationError: '',
    }
  },

  onLoginSubmit (event) {
    event.preventDefault()
    let {username, password} = this.state
    if (!username || !password) {
      this.setState({
        validationError: 'Username or password should not be empty.',
      })
    } else {
      this.setState({
        validationError: '',
      })
      this.props.fetchToken(this.state, this.props.history)
    }
  },

  handleChange (event) {
    let target = event.target
    this.setState({
      [target.name]: target.value,
    })
  },

  sendMail (event) {
    this.props.isLoading ? event.preventDefault() : window.location.href = 'mailto:ithelp@creditsafe.com'
  },

  renderErrorMessage () {
    let {validationError} = this.state
    let {authError, isTokenExpired} = this.props
    if (isTokenExpired) {
      return <div className="error">Token expired. Please login to continue.</div>
    } else if (validationError) {
      return <div className="error">{validationError}</div>
    } else if (authError) {
      return <div className="error">{authError}</div>
    }
    return false
  },

  render () {
    let {isLoading} = this.props
    return (
      <div className="login-container">
        <form onSubmit={this.onLoginSubmit}>
          {this.renderErrorMessage()}
          <div className="form-field env-row flex-display">
            <label htmlFor='env-select' className="env-label">Environment</label>
            <select id='env-select' name="env" value={this.state.env} onChange={this.handleChange} disabled={isLoading}>
              <option value="test">Test</option>
              <option value="stage">Stage</option>
              <option value="live">Live</option>
            </select>
          </div>
          <div className="form-field flex-display">
            <label htmlFor='name-input' className="name-label">User Name</label>
            <input
              id='name-input'
              placeholder="username"
              name="username"
              type="text"
              value={this.state.username}
              onChange={this.handleChange}
              disabled={isLoading}/>
          </div>
          <div className="form-field flex-display">
            <label htmlFor='password-input' className="password-label">Password</label>
            <input
              id='password-input'
              placeholder="password"
              name="password"
              type="password"
              value={this.state.password}
              onChange={this.handleChange}
              disabled={isLoading}/>
          </div>
          <div className="form-field btn-container flex-display">
            <button className='btn btn-block' type="submit" disabled={isLoading}>{isLoading ? <i className="fa fa-spinner fa-spin"></i> : ''}Sign In</button>
          </div>
          <div className="flex-display">
            <a onClick={this.sendMail} className="forgot-password">Forgotten Password?</a>
          </div>
        </form>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./src/components/forms/login-form.js